import { GameConfigs, EventConfig } from "kadow-jetpack-model";
import { GameTypes } from "kadow-jetpack-model";
import { GameThumbnailDTO } from "../../model/GameDTO";

export function buildGameThumbnailDTO(
  res: GameThumbnailDTO[],
  events: EventConfig[] | undefined | null,
  eventId: string,
  gameType: GameTypes | keyof GameConfigs,
  sts?: number,
  ets?: number
) {
  const event = events?.find((e) => e._id === eventId);

  if (!event) {
    return;
  }

  const config = event.skins?.find((s) => s.game === gameType)?.gameCardConfig;

  if (!config) {
    return;
  }

  res.push({
    name: gameType,
    config,
    eventId: event._id,
    sts,
    ets
  });
}
